import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'chunky-check-box',
  templateUrl: './check-box.component.html',
  styleUrls: ['./check-box.component.css']
})
export class ChunkyCheckBoxComponent {

  constructor() { }

  @Input() checked: boolean;
  @Output() checkedChange = new EventEmitter<boolean>();

  @Output() changed = new EventEmitter<boolean>();

  toggleCheck() {
    this.checked = !this.checked;
    this.checkedChange.emit(this.checked);
    this.changed.emit(this.checked);
  }

}
